import { c as _c } from "react/compiler-runtime";
import { FormSelect, Tooltip } from '@systemeio/ui';
import { AffiliateDashboardLeadOptionSource } from 'modules/affiliate-dashboard/components/affiliate-dashboard-lead-option-source';
import { useAffiliateDashboardLeads } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-leads';
import { AffiliateDashboardFilterInterface, AffiliateDashboardFilterWithTagInterface, TagId } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { AffiliateDashboardLeadOptionInterface, AffiliateDashboardLeadsInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-leads-interface';
import React, { useEffect, useState } from 'react';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { SelectorDataInterface } from 'shared/types/selector-data-interface';
import { dateFormat, dateTimeFormat } from 'shared/utils/date-time-format';
import { ArrowDownIcon } from '@systemeio/ui/icons';
interface AffiliateDashboardLeadsProps {
  mainFilter: AffiliateDashboardFilterInterface;
  defaultFilter: AffiliateDashboardFilterInterface;
  tagsData: SelectorDataInterface<TagId>[] | undefined;
  setMainFilter: React.Dispatch<React.SetStateAction<AffiliateDashboardFilterInterface>>;
}
const AffiliateDashboardLeads = t0 => {
  const $ = _c(74);
  const {
    mainFilter,
    tagsData,
    defaultFilter,
    setMainFilter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    limit,
    setLimit,
    pagination,
    setPagination,
    clearPagination
  } = usePagination(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [opened, setOpened] = useState(t1);
  let t2;
  if ($[1] !== defaultFilter) {
    t2 = {
      ...defaultFilter,
      affiliateTag: undefined
    };
    $[1] = defaultFilter;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [filterWithTag, setFilterWithTag] = useState(t2);
  let t3;
  if ($[3] !== clearPagination) {
    t3 = tagId => {
      setFilterWithTag(prev => ({
        ...prev,
        affiliateTag: tagId
      }));
      clearPagination();
    };
    $[3] = clearPagination;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const changeTag = t3;
  let t4;
  let t5;
  if ($[5] !== mainFilter) {
    t4 = () => {
      setFilterWithTag(prev_0 => ({
        ...prev_0,
        ...mainFilter
      }));
    };
    t5 = [mainFilter];
    $[5] = mainFilter;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== clearPagination) {
    t6 = () => {
      clearPagination();
    };
    $[8] = clearPagination;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== clearPagination || $[11] !== mainFilter) {
    t7 = [mainFilter, clearPagination];
    $[10] = clearPagination;
    $[11] = mainFilter;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  useEffect(t6, t7);
  let t8;
  if ($[13] !== filterWithTag || $[14] !== limit || $[15] !== pagination) {
    t8 = {
      filter: filterWithTag,
      pagination,
      limit
    };
    $[13] = filterWithTag;
    $[14] = limit;
    $[15] = pagination;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const {
    affiliateLeads,
    counter
  } = useAffiliateDashboardLeads(t8);
  let t10;
  let t9;
  if ($[17] !== affiliateLeads) {
    t9 = () => {
      if (affiliateLeads) {
        setOpened(affiliateLeads.items.reduce(_temp, {}));
      }
    };
    t10 = [affiliateLeads];
    $[17] = affiliateLeads;
    $[18] = t10;
    $[19] = t9;
  } else {
    t10 = $[18];
    t9 = $[19];
  }
  useEffect(t9, t10);
  let t11;
  if ($[20] !== t) {
    t11 = t("dashboard.affiliate_dashboard.vendor");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== setMainFilter) {
    t12 = lead => <div className="flex items-center gap-1.5 truncate"><button onClick={() => setMainFilter(prev_1 => ({
        ...prev_1,
        vendorId: lead.contact.user.id
      }))} className="ring-brand-primary h-[32px] w-[32px] shrink-0 rounded-full outline-hidden ring-offset-2 focus-visible:ring-2"><img alt={lead.contact.user.affiliateProgramBrandName} className="h-[32px] w-[32px] rounded-full" src={lead.contact.user.avatar} /></button><div className="flex w-full flex-col truncate"><span className="truncate">{lead.contact.user.affiliateProgramBrandName}</span><span className="block truncate">{lead.contactEmail}</span></div></div>;
    $[22] = setMainFilter;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = {
      key: "email",
      header: t11,
      widthPercent: 30,
      onRender: t12
    };
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t("dashboard.affiliate_dashboard.source_url");
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  let t16;
  if ($[29] !== changeTag || $[30] !== opened) {
    t15 = lead_0 => <AffiliateReferOptions opened={opened[lead_0.contact.id]} changeTag={changeTag} lead={lead_0} />;
    t16 = lead_1 => <AffiliateMobileOptions opened={opened[lead_1.contact.id]} changeTag={changeTag} lead={lead_1} setOpened={setOpened} />;
    $[29] = changeTag;
    $[30] = opened;
    $[31] = t15;
    $[32] = t16;
  } else {
    t15 = $[31];
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t14 || $[34] !== t15 || $[35] !== t16) {
    t17 = {
      key: "affiliateOptins",
      header: t14,
      widthPercent: 50,
      onRender: t15,
      onRenderSmall: t16
    };
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t) {
    t18 = t("global.date");
    $[37] = t;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== opened) {
    t19 = lead_2 => <AffiliateDateOptions lead={lead_2} opened={opened[lead_2.contact.id]} setOpened={setOpened} />;
    $[39] = opened;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t18 || $[42] !== t19) {
    t20 = {
      key: "affiliateOptins",
      header: t18,
      widthPercent: 20,
      onRender: t19,
      onRenderSmall: _temp2
    };
    $[41] = t18;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t13 || $[45] !== t17 || $[46] !== t20) {
    t21 = [t13, t17, t20];
    $[44] = t13;
    $[45] = t17;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  const columns = t21;
  let t22;
  if ($[48] !== t) {
    t22 = t("dashboard.affiliate.leads.title");
    $[48] = t;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t) {
    t23 = t("dashboard.affiliate_dashboard.any_tag");
    $[50] = t;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = data => setFilterWithTag(prev_2 => ({
      ...prev_2,
      affiliateTag: data
    }));
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== filterWithTag.affiliateTag || $[54] !== t23 || $[55] !== tagsData) {
    t25 = <FormSelect placeholder={t23} value={filterWithTag.affiliateTag} data={tagsData} onChange={t24} />;
    $[53] = filterWithTag.affiliateTag;
    $[54] = t23;
    $[55] = tagsData;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== limit || $[58] !== setLimit) {
    t26 = {
      limit,
      setLimit
    };
    $[57] = limit;
    $[58] = setLimit;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== pagination || $[61] !== setPagination) {
    t27 = {
      pagination,
      setPagination
    };
    $[60] = pagination;
    $[61] = setPagination;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] !== affiliateLeads || $[64] !== columns || $[65] !== t26 || $[66] !== t27) {
    t28 = <Table nestedId="contact" data={affiliateLeads} columns={columns} limiter={t26} paginator={t27} />;
    $[63] = affiliateLeads;
    $[64] = columns;
    $[65] = t26;
    $[66] = t27;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== affiliateLeads || $[69] !== counter || $[70] !== t22 || $[71] !== t25 || $[72] !== t28) {
    t29 = <ListingLayout counter={counter} data={affiliateLeads} title={t22} type="compact" customHeaderElement={t25}>{t28}</ListingLayout>;
    $[68] = affiliateLeads;
    $[69] = counter;
    $[70] = t22;
    $[71] = t25;
    $[72] = t28;
    $[73] = t29;
  } else {
    t29 = $[73];
  }
  return t29;
};
const AffiliateMobileOptions = t0 => {
  const $ = _c(17);
  const {
    lead,
    changeTag,
    opened,
    setOpened
  } = t0;
  let t1;
  if ($[0] !== changeTag || $[1] !== lead.affiliateOptins || $[2] !== opened) {
    let t2;
    if ($[4] !== changeTag || $[5] !== opened) {
      t2 = (opt, idx) => {
        if (idx === 0) {
          return <AffiliateMobileOptionItem key={idx} item={opt} changeTag={changeTag} />;
        } else {
          if (opened) {
            return <AffiliateMobileOptionItem key={idx} item={opt} changeTag={changeTag} />;
          }
        }
      };
      $[4] = changeTag;
      $[5] = opened;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = lead.affiliateOptins.map(t2);
    $[0] = changeTag;
    $[1] = lead.affiliateOptins;
    $[2] = opened;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <ul className="flex w-full flex-col gap-3 truncate">{t1}</ul>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== lead.affiliateOptins.length || $[10] !== lead.contact || $[11] !== opened || $[12] !== setOpened) {
    t3 = lead.affiliateOptins.length > 1 && <button onClick={() => setOpened(prev => ({
      ...prev,
      [lead.contact.id]: !prev[lead.contact.id]
    }))} className="bg-brand-primary ring-brand-primary flex h-5 w-5 shrink-0 items-center justify-center rounded-full outline-hidden ring-offset-2 focus-visible:ring-2"><ArrowDownIcon className={`stroke-background-secondary h-3 w-3 ${opened && "rotate-180"} transition-transform duration-200`} /></button>;
    $[9] = lead.affiliateOptins.length;
    $[10] = lead.contact;
    $[11] = opened;
    $[12] = setOpened;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t2 || $[15] !== t3) {
    t4 = <div className="flex w-full items-center justify-between gap-5 truncate">{t2}{t3}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};
const AffiliateMobileOptionItem = t0 => {
  const $ = _c(19);
  const {
    item,
    changeTag
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] !== item.sourceText || $[1] !== item.sourceUrl) {
    t1 = <AffiliateDashboardLeadOptionSource sourceUrl={item.sourceUrl} sourceText={item.sourceText} />;
    $[0] = item.sourceText;
    $[1] = item.sourceUrl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== changeTag || $[4] !== item.affiliateTag) {
    t2 = item.affiliateTag && <button onClick={() => item.affiliateTag && changeTag(item.affiliateTag.id)} className="ring-brand-primary bg-background-primary text-text-primary h-fit w-fit rounded-lg px-2 py-1 outline-hidden ring-offset-2 focus-visible:ring-2">{item.affiliateTag.name}</button>;
    $[3] = changeTag;
    $[4] = item.affiliateTag;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex items-center gap-3">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = user?.dateFormat;
  const t5 = user?.timeFormat;
  const t6 = user?.timezone;
  let t7;
  if ($[9] !== item.date || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = dateTimeFormat(item.date, {
      dateFormat: t4,
      timeFormat: t5,
      timeZone: t6
    });
    $[9] = item.date;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <span className="w-full truncate">{t7}</span>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t3 || $[17] !== t8) {
    t9 = <li className="flex flex-col">{t3}{t8}</li>;
    $[16] = t3;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
const AffiliateReferOptions = t0 => {
  const $ = _c(9);
  const {
    lead,
    changeTag,
    opened
  } = t0;
  let t1;
  if ($[0] !== changeTag || $[1] !== lead.affiliateOptins || $[2] !== opened) {
    let t2;
    if ($[4] !== changeTag || $[5] !== opened) {
      t2 = (opt, idx) => {
        if (idx === 0) {
          return <AffiliateReferOptionItem key={idx} item={opt} changeTag={changeTag} />;
        } else {
          if (opened) {
            return <AffiliateReferOptionItem key={idx} item={opt} changeTag={changeTag} />;
          }
        }
      };
      $[4] = changeTag;
      $[5] = opened;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = lead.affiliateOptins.map(t2);
    $[0] = changeTag;
    $[1] = lead.affiliateOptins;
    $[2] = opened;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <ul className="flex w-full flex-col gap-1.5 truncate">{t1}</ul>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
const AffiliateDateOptions = t0 => {
  const $ = _c(15);
  const {
    lead,
    opened,
    setOpened
  } = t0;
  let t1;
  if ($[0] !== lead.affiliateOptins || $[1] !== opened) {
    let t2;
    if ($[3] !== opened) {
      t2 = (opt, idx) => {
        if (idx === 0) {
          return <AffiliateDateOptionItem key={idx} item={opt} />;
        } else {
          if (opened) {
            return <AffiliateDateOptionItem key={idx} item={opt} />;
          }
        }
      };
      $[3] = opened;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = lead.affiliateOptins.map(t2);
    $[0] = lead.affiliateOptins;
    $[1] = opened;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <ul className="flex w-full flex-col gap-1.5 truncate">{t1}</ul>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== lead.affiliateOptins.length || $[8] !== lead.contact || $[9] !== opened || $[10] !== setOpened) {
    t3 = lead.affiliateOptins.length > 1 && <button onClick={() => setOpened(prev => ({
      ...prev,
      [lead.contact.id]: !prev[lead.contact.id]
    }))} className="bg-brand-primary ring-brand-primary flex h-5 w-5 shrink-0 items-center justify-center rounded-full outline-hidden ring-offset-2 focus-visible:ring-2"><ArrowDownIcon className={`stroke-background-secondary h-3 w-3 ${opened && "rotate-180"} transition-transform duration-200`} /></button>;
    $[7] = lead.affiliateOptins.length;
    $[8] = lead.contact;
    $[9] = opened;
    $[10] = setOpened;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <div className="flex items-center justify-between gap-5 truncate">{t2}{t3}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
const AffiliateReferOptionItem = t0 => {
  const $ = _c(9);
  const {
    item,
    changeTag
  } = t0;
  let t1;
  if ($[0] !== item.sourceText || $[1] !== item.sourceUrl) {
    t1 = <AffiliateDashboardLeadOptionSource sourceUrl={item.sourceUrl} sourceText={item.sourceText} />;
    $[0] = item.sourceText;
    $[1] = item.sourceUrl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== changeTag || $[4] !== item.affiliateTag) {
    t2 = item.affiliateTag && <button onClick={() => item.affiliateTag && changeTag(item.affiliateTag.id)} className="ring-brand-primary bg-background-primary text-text-primary h-fit w-fit rounded-lg px-2 py-1 outline-hidden ring-offset-2 focus-visible:ring-2">{item.affiliateTag.name}</button>;
    $[3] = changeTag;
    $[4] = item.affiliateTag;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <li className="flex items-center justify-between gap-3">{t1}{t2}</li>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
const AffiliateDateOptionItem = t0 => {
  const $ = _c(14);
  const {
    item
  } = t0;
  const {
    user
  } = useUser();
  const t1 = user?.timeFormat;
  const t2 = user?.dateFormat;
  const t3 = user?.timezone;
  let t4;
  if ($[0] !== item.date || $[1] !== t1 || $[2] !== t2 || $[3] !== t3) {
    t4 = dateTimeFormat(item.date, {
      timeFormat: t1,
      dateFormat: t2,
      timeZone: t3
    });
    $[0] = item.date;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = user?.dateFormat;
  const t6 = user?.timezone;
  let t7;
  if ($[5] !== item.date || $[6] !== t5 || $[7] !== t6) {
    t7 = dateFormat(item.date, {
      dateFormat: t5,
      timeZone: t6
    });
    $[5] = item.date;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7) {
    t8 = <span className="w-full truncate">{t7}</span>;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t4 || $[12] !== t8) {
    t9 = <li><Tooltip wrapperClassName="w-full" mode="hover" label={t4}>{t8}</Tooltip></li>;
    $[11] = t4;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};
export default AffiliateDashboardLeads;
function _temp(acc, cur) {
  return {
    ...acc,
    [cur.contact.id]: false
  };
}
function _temp2() {
  return <></>;
}